import { Om2FormFieldBase } from './common/base.js';

/**
 * Render a custom form field. The schema must have a render function defined which
 * takes two arguments (a field object, and schema object), and returns a lit template
 * to render. Events of type "input" that are emitted represent changes to the value
 * of this field. Ideally they are sent as:
 *
 *    new CustomEvent('input', { detail: { name: field.key, value: value, }, bubbles: true, })
 *
 * Be aware of whether to render differently when readonly (field.context.readonly === true).
 */
export class Om2FormFieldCustom extends Om2FormFieldBase {
  static metadata = {
    // This field type will not be part of the form builder
    unsupported: true,
  };

  render() {
    const { schema } = this;
    return schema.render(this, schema);
  }
}

Om2FormFieldCustom.register('custom');
